<div class="modal-content">
  <!--Header-->
  <div
    class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0"
    >
    <div class="modal-title">
      @if (header) {
        <h4 class="text-light mb-0">{{ header }}</h4>
      }
      @if (!header) {
        <h4 class="text-light mb-0">Digital Signature</h4>
      }
    </div>
    <button
      type="button"
      class="close-btn"
      style="margin-left: auto"
      (click)="closeModalClick()"
      >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <!--Body-->
  <div class="modal-body pb-4 d-flex flex-column align-items-center">
    <!-- digital-signature.component.html -->
    <div class="mb-4 w-100 d-flex justify-content-center">
      <canvas
        #signaturePad
        width="600"
        height="200"
        class="signature-canvas shadow-sm"
      ></canvas>
    </div>

    <div class="d-flex justify-content-between w-100" style="max-width: 600px">
      <button class="btn modern-btn secondary-btn px-4" (click)="clear()">
        <i class="fa-solid fa-eraser me-2"></i>Clear
      </button>
      <button class="btn modern-btn primary-btn px-4" (click)="save()">
        <i class="fa-solid fa-save me-2"></i>Save
      </button>
    </div>
  </div>
</div>
